import script from "./addressBookPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./addressBookPopup.vue?vue&type=script&lang=ts&setup=true"

import "./addressBookPopup.vue?vue&type=style&index=0&id=1f369750&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f369750"]])

export default __exports__